import {Row, Col} from "react-bootstrap";
import useWindowDimensions from "../../utils/useWindowDimensions";

import styles from "./FooterMenu.module.css";

const date = new Date();
let year = date.getFullYear();
function FooterMenu() {
    const { height, width } = useWindowDimensions();
    return (
        <Row className={styles.ContentContainer}>
            <Col className="d-flex justify-content-between align-items-center">
                <div>
                    <div className={styles.votingSubtext}>© {year} Voton technology</div>
                </div>
                <div className={`${styles.socialIconCollection} d-flex justify-content-between`}>
                    <div className={styles.votingSubtext}>Language support</div>
                    <div className={styles.votingSubtext}>Privacy policy</div>
                    <div className={styles.votingSubtext}>Terms of use</div>
                    <div className={styles.votingSubtext}>Cookie policy</div>
                </div>
            </Col>
        </Row>
    );
}

export default FooterMenu;